import type { WeatherBundle } from './weather-types.js';

const STORAGE_KEY = 'cl-vivo-weather-cache-v1';

export interface CachedWeather {
  bundle: WeatherBundle;
  storedAt: string;
}

export function readWeatherCache(): CachedWeather | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CachedWeather;
    if (!parsed?.bundle?.current) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeWeatherCache(bundle: WeatherBundle): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ bundle, storedAt: new Date().toISOString() }));
  } catch {
    /* quota / private mode */
  }
}

export function ageMinutesFrom(iso: string): number {
  return Math.max(0, Math.round((Date.now() - Date.parse(iso)) / 60_000));
}
